/* global Raven */
import React from "react";
import Intercom from "react-intercom";
import { compose } from "react-apollo";
import { connect } from "react-redux";
import withCurrentUser from "../hocs/withCurrentUser";
import runtimeEnv from "@mars/heroku-js-runtime-env";

const env = runtimeEnv();

const HelpWidget = ({ userProps }) => {
  if (typeof Raven !== "undefined") {
    if (userProps) {
      Raven.setUserContext({
        email: userProps.email,
        id: userProps.user_id
      });
    } else {
      Raven.setUserContext();
    }
  }

  return <Intercom appID={env.REACT_APP_INTERCOM_ID} {...userProps || {}} />;
};

const enhance = compose(
  connect(state => ({
    isAuthenticated: state.auth.isAuthenticated
  })),
  withCurrentUser({
    skip: props => !props.isAuthenticated,
    props: ({ userData }) => {
      if (userData && userData.currentUser) {
        const { currentUser } = userData;
        return {
          userProps: {
            user_id: currentUser.id,
            name: currentUser.name,
            email: currentUser.email,
            user_hash: currentUser.intercomUserHash
          }
        };
      }

      return {};
    }
  })
);

export default enhance(HelpWidget);



// WEBPACK FOOTER //
// ./src/components/HelpWidget.js